import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { S } from '../../../routes/routes';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import './style.scss';

/* Json */
import { isEmpty, isNone } from 'iotera-base/object';
import {
  safeDeepGet,
  safeDeepGetWithType,
  parse,
  parseArray,
  stringifyFormatted,
  stringify,
} from 'iotera-base/json';

/* Json Editor */
import JsonEditor from '../../../lib/components/JsonEditor';

/* Result */
import Result from 'iotera-base/result';

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { domainIsTenant as dit } from '../../../routes/routes';

/* Sagas Actions */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks';
import { actions as notificationActions } from '../../../redux/ducks/notification';

import {
  DEVICE_CAT_KAA,
  DEVICE_CAT_LORA,
  DEVICE_CAT_ZLAN,
  DEVICE_CAT_DUMMY,
  DEVICE_CAT_MQTT,
  DEVICE_CAT_TASMOTA,
  DEVICE_CAT_UI,
  DEVICE_CAT_BIVOCOM,
  DEVICE_CAT_FRIENDCOM,
  DEVICE_CAT_IOTERA,
  DEVICE_CAT_EMMA,
  DEVICE_CAT_IMOU_CAMERA,
} from '../../../lib/components/Preference';
import { SubViewHeader } from '../../../lib/components/subHeader';
import { IoteraForm } from '../../../lib/components/form';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../lib/components/callbackGlobal';

// For Unique Id
const uuidv1 = require('uuid/v1');
let UNIQ;

const EDIT = 'EDIT';
const EDIT_DUMMY = 'EDIT_DUMMY';
const EDIT_MQTT = 'EDIT_MQTT';
const EDIT_TASMOTA = 'EDIT_TASMOTA';
const EDIT_LORA = 'EDIT_LORA';
const EDIT_ZLAN = 'EDIT_ZLAN';
const EDIT_UI = 'EDIT_UI';
const EDIT_BIVOCOM = 'EDIT_BIVOCOM';
const EDIT_FRIENDCOM = 'EDIT_FRIENDCOM';
const EDIT_IOTERA = 'EDIT_IOTERA';
const EDIT_EMMA = 'EDIT_EMMA';
const EDIT_IMOU_CAMERA = 'EDIT_IMOU_CAMERA';
const WKEY = 'DEVICE_INFO';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const schema = {
  type: 'object',
  required: ['sensors'],
  properties: {
    sensors: { type: 'string', title: 'Konfigurasi', minLength: 0 },
  },
};

const uiSchema = {
  sensors: {
    'ui:widget': props => {
      return (
        <div style={{ padding: 1, border: '1px solid #CED4DA' }}>
          <JsonEditor {...props} />
        </div>
      );
    },
  },
};

class DeviceEdit extends Component {
  constructor(props) {
    super(props);
    const deviceId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    UNIQ = uuidv1();
    this.state = {
      value: [],
      formData: {},
      values: '',
      deviceId,
      loading: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onEditSensorsFinished = this.onEditSensorsFinished.bind(this);
  }

  onEditSensorsFinished(id, result) {
    if (result.code === Result.HTTP.OK) {
      const responseResult = safeDeepGetWithType(
        result,
        ['body', 'response_result'],
        Result.UNKNOWN_ERROR
      );
      if (responseResult === Result.SUCCESS) {
        this.setState({
          loading: false,
        });
        this.props.history.push('..' + S + '..' + S + '_device_list_');
        this.props.showSingleNotification({
          message: 'Edit Perangkat Sukses',
          level: 'success',
        });
        return;
      }
    }
    this.setState({
      loading: false,
    });
    this.props.showSingleNotification({
      message: 'Edit Perangkat Gagal',
      position: 'tr',
      level: 'error',
    });
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const deviceId = safeDeepGet(_state, ['deviceId'], '');
    if (isEmpty(deviceId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      wparam: {
        ...domainIsTenant,
        path: '/service/web/device/get/id/' + deviceId,
      },
      wcallback: {
        started: function (id) {
          // TODO Loading
        },
        finished: function (id, result) {
          // TODO Loading
        },
      },
      wreducer: {
        rparse: function (id, result, rpayload) {
          let device = rpayload;
          let deviceTemp = {};
          let ids = device['id'];
          deviceTemp.id = ids;
          deviceTemp.category = device['category'];
          deviceTemp.bandwidth = 57;
          deviceTemp.temperature = 36;
          deviceTemp.components = [];
          deviceTemp.length = 1;
          deviceTemp.data = 60;
          deviceTemp.deviceType = [device.category];
          deviceTemp.hardware = 'Raspberry Pi';
          deviceTemp.firmware = '1.0';
          deviceTemp.name = device['name'];
          deviceTemp.location = [];
          deviceTemp.selected = false;
          deviceTemp.sensors = stringifyFormatted(
            safeDeepGet(device, 'sensors')
          ); //after
          deviceTemp.serial_number = device['serial_number'];
          deviceTemp.status = [device['online'] ? 'on' : 'off'];
          deviceTemp.storage = 70;
          deviceTemp.cpu = 50;
          deviceTemp.memory = 20;
          _this.setState({ loading: false });
          return deviceTemp;
        },
      },
    });
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/k/end/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_LORA]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/l/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_DUMMY]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/dum/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_MQTT]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/mqtt/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_TASMOTA]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/tasmota/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_ZLAN]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/z/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_UI]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/ui/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_BIVOCOM]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/b/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_FRIENDCOM]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/friendcom/node/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_IOTERA]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/io/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_EMMA]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/emma/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
        [EDIT_IMOU_CAMERA]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/imouc/edit/sensors',
          },
          wcallback: {
            finished: function (id, result) {
              _this.onEditSensorsFinished(id, result);
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const deviceId = safeDeepGet(_state, ['deviceId'], '');
    if (isEmpty(deviceId)) {
      return {};
    }
    // callback global
    unsetCallbackGlobal(_props);
    _props.wUnsetConfig({ key: WKEY });
  }

  handleChange(event) {
    this.setState({ formData: event.formData });
  }

  handleSubmit() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    let submitData = safeDeepGet(_state, ['formData']);
    if (isEmpty(submitData)) {
      submitData = safeDeepGet(_props, ['device']);
    }
    const sensors = safeDeepGet(submitData, ['sensors']);
    let sensors_object = parse(sensors);
    if (isNone(sensors_object)) {
      sensors_object = parseArray(sensors);
    }
    if (isNone(sensors_object)) {
      submitData['sensors'] = stringify(sensors_object);
      _props.showSingleNotification({
        message: 'Konfigurasi harus dalam bentuk JSON yang benar',
        level: 'warning',
      });
      _this.setState({ formData: submitData });
      return;
    }
    submitData['sensors'] = stringifyFormatted(sensors_object);
    _this.setState({ formData: submitData });
    const id = safeDeepGetWithType(_props, ['deviceId'], '');
    const cat = safeDeepGetWithType(_props, ['deviceCat'], -1);
    _this.setState({
      loading: true,
    });
    let _id = EDIT;
    if (cat === DEVICE_CAT_DUMMY) {
      _id = EDIT_DUMMY;
    } else if (cat === DEVICE_CAT_KAA) {
      _id = EDIT;
    } else if (cat === DEVICE_CAT_MQTT) {
      _id = EDIT_MQTT;
    } else if (cat === DEVICE_CAT_TASMOTA) {
      _id = EDIT_TASMOTA;
    } else if (cat === DEVICE_CAT_LORA) {
      _id = EDIT_LORA;
    } else if (cat === DEVICE_CAT_ZLAN) {
      _id = EDIT_ZLAN;
    } else if (cat === DEVICE_CAT_BIVOCOM) {
      _id = EDIT_BIVOCOM;
    } else if (cat === DEVICE_CAT_FRIENDCOM) {
      _id = EDIT_FRIENDCOM;
    } else if (cat === DEVICE_CAT_IOTERA) {
      _id = EDIT_IOTERA;
    } else if (cat === DEVICE_CAT_UI) {
      _id = EDIT_UI;
    } else if (cat === DEVICE_CAT_EMMA) {
      _id = EDIT_EMMA;
    } else if (cat === DEVICE_CAT_IMOU_CAMERA) {
      _id = EDIT_IMOU_CAMERA;
    }
    _props.wSingleRequestCall({
      id: _id,
      body: {
        id,
        sensors: sensors_object,
      },
    });
  }

  goTo(link) {
    this.props.history.push(link);
  }

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const { formData, loading } = _state;
    let dataToShow = {};
    if (!isEmpty(formData)) {
      dataToShow = formData;
    } else {
      let device = safeDeepGet(_props, ['device'], {});
      if (!isEmpty(device)) {
        dataToShow = device;
      }
    }
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#000" />
      </div>
    );
    if (!isEmpty(dataToShow)) {
      return (
        <Loader
          show={loading}
          message={spinner}
          backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}
        >
          <div className="view">
            <SubViewHeader
              title="Edit Device"
              subTitle="Formulir Edit Konfigurasi Device"
            />
            <div className="io-container mt-12">
              <IoteraForm
                schema={schema}
                uiSchema={uiSchema}
                onChange={_this.handleChange}
                onSubmit={_this.handleSubmit}
                formData={dataToShow}
              >
                <div className="button-right" style={{ marginTop: 10 }}>
                  <button
                    className="button-iotera-white"
                    type="button"
                    style={{ minWidth: '0%' }}
                    onClick={() =>
                      _this.goTo('..' + S + '..' + S + '_device_list_')
                    }
                  >
                    Batal
                  </button>
                  <button
                    className="button-iotera-primary"
                    type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}
                  >
                    Simpan
                  </button>
                </div>
              </IoteraForm>
            </div>
          </div>
        </Loader>
      );
    } else {
      return (
        <div className="view">
          <SubViewHeader
            title="Edit Device"
            subTitle="Formulir Edit Konfigurasi Device"
          />
          <div className="io-container mt-12"></div>
        </div>
      );
    }
  }
}

const mapStateToProps = function (state) {
  return {
    device: wSelector.getSoleInitMappedRPayload(state),
    deviceId: wSelector.getSoleInitMappedRPayload(state, 'id'),
    deviceCat: wSelector.getSoleInitMappedRPayload(state, 'category'),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DeviceEdit));
